module.exports = __webpack_public_path__ + "static/media/ticketgraph.cd687562.svg";